<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-stati-patrimoniali page-operative-stati-patrimoniali-new">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Nuovo Stato Patrimoniale a consuntivo</PageTitle>
        <app-router-link class="btn btn-outline-primary" :to="{ name: 'operative-company.data-analysis.stati-patrimoniali' }">Torna alla lista</app-router-link>
      </div>

      <FormStatoPatrimoniale @saved="saveStatoPatrimoniale" />
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-stati-patrimoniali-new',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    FormStatoPatrimoniale: () => import('../../../../components/Operative/Form/FormStatoPatrimoniale'),
    AppRouterLink: () => import('../../../../components/Layout/AppRouterLink'),
  },
  methods: {
    saveStatoPatrimoniale (statoPatrimoniale) {
      this.$api.addStatoPatrimoniale(this.company.id, statoPatrimoniale)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.stati-patrimoniali',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
};

</script>
